import React from 'react'
import ReactLoading, { LoadingType } from 'react-loading'

interface LoadingProps {
    loading: boolean,
    type?: LoadingType,
    className?: string
}

export default class Loading extends React.Component<LoadingProps> {
    render(){
        return (
            <div className={`loading-warp ${this.props.loading ? 'is-loading' : ''} ${this.props.className || ''} ${this.props.type || ''}`}>
                { this.props.children }
                { this.props.loading ? <ReactLoading className='loading' type={ this.props.type || 'bars'} color='#f4e4ab'></ReactLoading> : null}
            </div>
            
        )
    }
}